function minLengthValidator(value: string, length: number) {
  return (value ?? '').length >= length;
}

export default minLengthValidator;
